module.exports = __webpack_public_path__ + "img/ChatIcon.18a9d7e4.png";